import React from 'react';

const header = () => {
    return ( 
        <h1 style={{color:'#eee'}}>Minhas Tarefas</h1>
     );
}
 
export default header;